import { DatePipe } from '@angular/common';
import { Component, OnInit, DoCheck, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { GamesService } from '../../../services/games.service';
import { GamesDetailsModalComponent } from '../games-details-modal/games-details-modal.component';
import { RevertPayoutDetailsComponent } from '../revert-payout-details/revert-payout-details.component';
import { GamesHistoryTableComponent } from '../tables/games-history-table/games-history-table.component';
import { MarketplaceOrderStatus } from '../../../models/marketplace-order.model';

type CustomReward = {
  PointStoreProductID: number;
  Title: string;
};

type RaffleRewardsProducts = {
  [key: number]: CustomReward;
};

enum HistoryView {
  GameBreakdown,
  PlayerBreakdown
}

@Component({
  selector: 'cv-games-history',
  templateUrl: './games-history.component.html',
  styleUrls: ['./games-history.component.scss']
})

export class GamesHistoryComponent implements OnInit {
  @ViewChild(GamesHistoryTableComponent, { static: false }) historyTable: GamesHistoryTableComponent;

  gs = null;
  gamesListObject = [];
  isLoading: boolean = false;

  orderBy = {
    key: 'EndDate',
    reversed: true,
  };

  gridData = [];
  participantsInfo = [];
  actionHistory: any = [];
  raffleRewardsProducts: RaffleRewardsProducts = {};

  //Revert Payments variables
  selectAll: boolean = false;
  reversion: boolean = false;
  showModal: boolean = false;
  modalFlag: boolean = false;
  
  searchGameText: string = "";
  searchIntervalText: string = "";
  enableSelection: boolean = false;

  //Observables
  filteredGames$: Observable<Array<any>> = new Observable<[]>();
  filteredIntervals$: Observable<Array<any>> = new Observable<[]>();

  oldHistoryItems: number = 0;
  oldSelectedInterval: any = null;
  oldModalResponse: string = "";
  intervalForDisplay: any;
  abortRequest = {};

  dropdownOpen: boolean = false;
  alreadyFormatted = false;
  participantsInfoExport = [];
  gmf = null;
  columns: any;
  totalRow: any;
  exportData: any;
  startDate: any = "any";
  endDate: any = "";
  HistoryView = HistoryView;
  selectedHistoryView: HistoryView = HistoryView.GameBreakdown;

  constructor(
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private gamesService: GamesService,
    private navigationService: NavigationService,
    private metricFormatPipe: GenericMetricFormatterPipe,
    private cdr: ChangeDetectorRef
  ) { 
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    if (this.gs.GameFolders.length > 0) {
      this.loadGamesList();
    } else {
      this.isLoading = true;
    }
  }

  ngDoCheck(): void {
    const currentHistoryLength = this.gs.GameFoldersForHistory.length;
    if (this.oldHistoryItems !== currentHistoryLength) {
      this.oldHistoryItems = currentHistoryLength;
      this.loadGamesList();
      this.cdr.detectChanges();
    }
  
    const selectedInterval = this.gs.selectedInterval[0];
    if (JSON.stringify(this.oldSelectedInterval) !== JSON.stringify(selectedInterval)) {
      this.oldSelectedInterval = selectedInterval;
      this.updateSelectedInterval();
      this.cdr.detectChanges();
    }
  
    if (this.oldModalResponse !== this.gs.modalResponse) {
      this.oldModalResponse = this.gs.modalResponse;
      this.handleModalResponse();
      this.cdr.detectChanges();
    }
  }
  
  private updateSelectedInterval(): void {
    if (this.gs.selectedInterval.length > 0) {
      this.loadGamesHistory();
    } else {
      this.clearDataTable();
    }
  }
  
  private handleModalResponse(): void {
    if (this.gs.modalResponse === "PaymentReverted") {
      this.loadGamesHistory();
    }
    this.gs.modalResponse = "";
  }

  clearDataTable () {
    this.participantsInfo = [];
    this.enableSelection = false;
    this.selectAll = false;
    this.reversion = false;
  }

  openGameDetail () {
    if (!(this.gs.selectedGame.length > 0))
      return;

    //Sort rewards of Milestone
    if (this.gs.selectedGame[0].GameType == 5) {
      this.gs.selectedGame[0].MilestoneRewards.sort((a, b) => { return (a.RuleLevelID < b.RuleLevelID) ? 1 : -1 });
    }

    const modalRef = this.modalService.open(GamesDetailsModalComponent, {      
      ariaDescribedBy: 'card-body',      
      backdrop: 'static',
      backdropClass: 'stopScrolling',    
      size: 'modal-dialog-noborder-when-loading modal-dialog-centered modal-sm-custom',
    });

    modalRef.result.finally(() => {
      this.navigationService.showOverlay = false;
    });
  }

  loadGamesList () {
    this.filteredGames$ = of([]);
    this.isLoading = true;
    this.gs.gamesList = [];
    let tmpList = angular.copy(this.gs.GameFolders);
    this.gs.gamesList = this.formatGamesList(tmpList, this.gs.selectedGame[0]);
    this.filteredGames$ = of(JSON.parse(JSON.stringify(this.gs.gamesList)));
    this.isLoading = false;
    this.participantsInfo = [];
  }

  filterGames(){
    this.isLoading = true;
    var folder = null;
    var tmpData = [];
    this.filteredGames$ = of([]);
    var rawData = JSON.parse(JSON.stringify(this.gs.gamesList));

    for(var i = 0; i < rawData.length; i++){
      if(rawData[i].gameFolderGroup != undefined && rawData[i].gameFolderGroup == true){
        folder = rawData[i];
      }

      if(rawData[i].underlyingRule != undefined && rawData[i].underlyingRule.RuleName.toLowerCase().indexOf(this.searchGameText.toLowerCase()) > -1) {
        if(folder.length != 0 && !tmpData.includes(rawData[i-1])){
          tmpData.push(folder);
          folder = [];
        }

        tmpData.push(rawData[i]);
      }
    }

    this.filteredGames$ = of(JSON.parse(JSON.stringify(tmpData)));
    this.isLoading = false;
  }

  filterIntervals(){
    this.isLoading = true;
    var tmpData = [];
    this.filteredIntervals$ = of([]);
    var rawData = JSON.parse(JSON.stringify(this.gs.selectedGame[0].Intervals));

    for(var i = 0; i < rawData.length; i++){
      if(rawData[i].DisplayStringDate.indexOf(this.searchIntervalText.toLocaleLowerCase()) > -1){
        tmpData.push(rawData[i]);
      }
    }

    this.filteredIntervals$ = of(JSON.parse(JSON.stringify(tmpData)));
    this.isLoading = false;
  }

  getResultValueForRaffle = (participantObject: { calculatedCoins: number, calculatedXP: number, custom: string, metric?: number, passed: boolean, results: string }) : string => {
    if(this.gs.selectedGame && this.gs.selectedGame[0]?.GameType == 9) {
      const { calculatedCoins, calculatedXP, custom = '' } = participantObject || {};
      if(!participantObject.metric && !calculatedCoins && !calculatedXP && !custom){
        return this.gamesService.getGamesHistoryMessages('No_Results', 'No results');
      }
      const passed = participantObject.passed && this.gamesService.getGamesHistoryMessages('Raffle_Participant', 'Raffle Participant');
      const noTicket = !Number.isNaN(participantObject.metric) ? 
      this.gamesService.getGamesHistoryMessages('No_Ticket', 'No Ticket') : this.gamesService.getGamesHistoryMessages('No_Results', 'No results');
      if (calculatedCoins > 0 || calculatedXP > 0 || custom) {
        return this.gamesService.getGamesHistoryMessages('Winner', 'Winner');
      }
      return passed || noTicket;
    }
    return participantObject.results;
  }

  /**
   * We need to cancel the request if the loadGameHistory is called again
   */
  loadGamesHistory () {
    this.changeTableOverlay(true);// show overlay
    this.enableSelection = false;
    this.selectAll = false;
    this.reversion = false;

    $(document).trigger(new jQuery.Event('cancelRevertSelection'));
    var ruleID = this.gs.selectedGame[0].underlyingRule.RuleID;
    var SelectedStartDate = this.gs.selectedInterval[0].StartDate;
    var SelectedEndDate = this.gs.selectedInterval[0].EndDate;

    this.endDate = this.gs.selectedInterval[0].EndDate;
    this.startDate = this.gs.selectedInterval[0].StartDate;

    var participants = null;
    this.participantsInfo = null;

    let bracketID;
    let previousRequest;

    //sort rewards of Milestone
    if (this.gs.selectedGame[0].GameType == 5) {
      this.gs.selectedGame[0].MilestoneRewards.sort((a, b) => { return (a.RuleLevelID < b.RuleLevelID) ? 1 : -1 });
    }

    //Get all the participants by Rule and Interval
    if (this.gs.selectedGame[0].GameType == 10) {
      let currentVersion = this.gs.selectedInterval[0].Version;

      const highestVersion = this.gs.selectedGame[0].Intervals.reduce((max, item) => (item.Version > max.Version ? item : max), this.gs.selectedGame[0].Intervals[0]).Version;

      if (currentVersion == highestVersion) {
        bracketID = this.gs.selectedGame[0].BracketTournamentDetails.BracketID;
        this.gs.selectedGame[0].HistoryBracketTournamentDetails = this.gs.selectedGame[0].BracketTournamentDetails;
        this.gs.selectedGame[0].HistoryBracketTournamentMatches = this.gs.selectedGame[0].BracketTournamentMatches;
        this.gs.selectedGame[0].HistoryBracketTournamentRounds = this.gs.selectedGame[0].BracketTournamentRounds;
        this.gs.selectedGame[0].HistoryEligibility = this.gs.selectedGame[0].Eligibility;
        previousRequest = Promise.resolve();
      } else {
        previousRequest = this.gs.selectedGame[0].HistoryBracketTournament = this.gamesService.getBracketMatchesByVersion(ruleID, this.gs.selectedInterval[0].Version).then((result: any) => {//TODO: Add the correct type
          this.gs.selectedGame[0].HistoryBracketTournamentDetails = result.TournamentDetails;
          this.gs.selectedGame[0].HistoryBracketTournamentMatches = result.TournamentMatches;
          this.gs.selectedGame[0].HistoryBracketTournamentRounds = result.TournamentRounds;
          this.gs.selectedGame[0].HistoryEligibility = result.HistoryEligibility;

          bracketID = this.gs.selectedGame[0].HistoryBracketTournamentDetails.BracketID;
        });
      }
    } else {
        previousRequest = Promise.resolve();
    }

    previousRequest.then(() => {
      this.gamesService.getParticipantsByRule(ruleID, SelectedStartDate, SelectedEndDate, bracketID).then((result: any) => {
        const prevRequest = this.getRequestId(ruleID, SelectedStartDate);
        if (this.abortRequest[prevRequest]) {
          this.abortRequest[prevRequest] = false;
          return Promise.reject();
        }
        //Avoiding duplicated participants
        participants = result?.filter((currentElement, index, selfArray) => {
          return index === selfArray.findIndex((t) => { 
            return t.participant.LoginID === currentElement.participant.LoginID;
          });
        });
    
        return this.gamesService.getRewardsByGameInterval(ruleID, SelectedStartDate, SelectedEndDate);
      }).then((response) => {
        this.actionHistory = response;
        angular.forEach(participants, (participantObject, key) => {
          //Verifying if user has joined the game
          if (!participantObject.participant.AlreadyJoined) {
            participantObject.metric = 0;
            participantObject.qualifier = 0;
            participantObject.passed = false;
            participantObject.results = this.gamesService.getLocalizedMessage("No_Results", "No Results");
            participantObject.calculatedCoins = 0;
            participantObject.calculatedXP = 0;
            participantObject.custom = '';
            participantObject.badges = [];
    
            if (this.gs.selectedGame[0].GameType == 6 || this.gs.selectedGame[0].GameType == 7) {
              participantObject.connect3Metrics = [];
            }
            return;
          }
    
          //To Get Action Coin, XP, Badge History
          if (this.actionHistory.length > 0) {
            participantObject.calculatedCoins = 0;
            participantObject.calculatedXP = 0;
            participantObject.badges = [];
            participantObject.isReverted = false;
            participantObject.reversionDate = null;
            participantObject.custom = '';
    
            angular.forEach(this.actionHistory, (actionItem) => {
              if (actionItem.LoginID == participantObject.participant.LoginID) {
                //ActionItem
                participantObject.calculatedCoins += (actionItem.ActionType == 0 || actionItem.ActionType == 6) ? actionItem.NumericValue : 0;
                participantObject.calculatedXP += (actionItem.ActionType == 1 || actionItem.ActionType == 7) ? actionItem.NumericValue : 0;
                if (actionItem.ActionType == 2 && actionItem.NumericValue) {
                  participantObject.badges.push(actionItem.NumericValue);
                }
    
                if (actionItem.ActionType == 10 && actionItem.TextValue && actionItem.TextValue.length > 0) { // raffle game
                  participantObject.custom = actionItem.TextValue;
                  participantObject.productState = actionItem.NumericValue || -1;
                }
                  
                participantObject.isReverted = actionItem.Reverted;
                participantObject.paidDate = actionItem.ActionDate;
                participantObject.reversionDate = actionItem.RevertedDate;
              }
            });
    
            if (participantObject.isReverted === null || participantObject.isReverted === undefined) {
              participantObject.paymentDate = "";
            } else {
              if (participantObject.calculatedCoins == 0 && participantObject.calculatedXP == 0) {
                participantObject.paymentDate = "---";
              } else {
                if (!participantObject.isReverted) {
                  participantObject.paymentDate = this.gamesService.getGamesHistoryMessages("Paid_on", "Paid on") + " " + this.datePipe.transform(participantObject.paidDate, CVAngularDateFormat);
                } else {
                  participantObject.paymentDate = this.gamesService.getGamesHistoryMessages("Reverted_on", "Reverted on") + " " + this.datePipe.transform(participantObject.reversionDate, CVAngularDateFormat);
                }
              }
            }
    
          } else {
            participantObject.calculatedCoins = 0;
            participantObject.calculatedXP = 0;
            participantObject.badges = [];
            participantObject.custom = '';
          };
    
          //To Get Metric and Qualifier per participant.
          if (participantObject.ruleObject.MyRankingObj && participantObject.ruleObject.MyRankingObj.MetricGroupInfos) {
            if (this.gs.selectedGame[0].Qualifier) {
              let Qualifier = participantObject.ruleObject.MyRankingObj.MetricGroupInfos.filter((a) => {
                return a.MetricID === this.gs.selectedGame[0].Qualifier.metricID;
              })[0];
    
              if (this.gs.selectedGame[0].GameType != 8) {
                participantObject.qualifier = Qualifier ? this.metricFormatPipe.transform(Qualifier.MyMetricValue, this.gs.selectedGame[0].Qualifier.conversionType) : this.metricFormatPipe.transform(0, this.gs.selectedGame[0].Qualifier.conversionType);
              } else {
                participantObject.qualifier = Qualifier ? Qualifier.MyMetricValue : 0;
              }
                
              participantObject.passed = this.isQualified(this.gs.selectedGame[0], Qualifier?.MyMetricValue ? Qualifier.MyMetricValue : 0);
            } else {
              participantObject.qualifier = 0;
              participantObject.passed = false;
            }    
    
            if (this.gs.selectedGame[0].GameType == 6 || this.gs.selectedGame[0].GameType == 7) {
              participantObject.connect3Metrics = [];
              let metricCompleted = [];
    
              //Sort the Positions
              this.gs.selectedGame[0].Connect3Positions.sort((a, b) => {
                return (a.position > b.position) ? 1 : -1;
              });
    
              this.gs.selectedGame[0].Connect3Positions.forEach((metricPosition) => {
                let metric = participantObject.ruleObject.MyRankingObj.MetricGroupInfos.filter((a) => {
                  return a.MetricID === metricPosition.metric.metricID;
                })[0];
    
                if (metric) {
                  metric.metricCompleted = false;
                  participantObject.connect3Metrics.push(metric);
                } else {
                  metric = { MetricID: metricPosition.metric.metricID, MyMetricValue: 0, metricCompleted: false };
                  participantObject.connect3Metrics.push(metric);
                }

                if (metricPosition.metric.metricID == -1) { metricCompleted[metricPosition.position] = true; participantObject.connect3Metrics[metricPosition.position].metricCompleted = true; } //Free Space = true

                if (metricPosition.metric != null && metricPosition.metric.metricID > -1 && metric != null) {
                  metricCompleted[metricPosition.position] = metricPosition.targetObj.Direction == 0 ? metric.MyMetricValue <= metricPosition.targetObj.Target : metric.MyMetricValue >= metricPosition.targetObj.Target;
                  participantObject.connect3Metrics[metricPosition.position].metricCompleted = metricCompleted[metricPosition.position];
                }
              });

              if (this.gs.selectedGame[0].Qualifier) {
                participantObject.results = participantObject.passed ? this.gs.selectedGame[0].GameType == 6 ? this.isWinnerConnect3(metricCompleted, this.gs.winCasesConnect3) : this.isWinnerBlackout(metricCompleted, this.gs.winCasesBlackout) : this.gamesService.getLocalizedMessage("Disqualified", "Disqualified");
              } else {
                participantObject.results = this.gs.selectedGame[0].GameType == 6 ? this.isWinnerConnect3(metricCompleted, this.gs.winCasesConnect3) : this.isWinnerBlackout(metricCompleted, this.gs.winCasesBlackout);
              }
            } else if (this.gs.selectedGame[0].GameType == 8) {
              participantObject.metric = participantObject.ruleObject?.MyRankingObj?.MetricGroupInfos?.[0]?.MyMetricValue ? participantObject.ruleObject.MyRankingObj.MetricGroupInfos[0].MyMetricValue : 0;
              participantObject.results = this.isWinnerTeamVsTeam(this.gs.selectedGame[0].TopDogRewards, participantObject);

              if (participantObject.results != this.gamesService.getLocalizedMessage("No_Results", "No Results")) {
                participantObject.passed = true;
              }

              if (!participantObject.passed && this.gs.selectedGame[0].Qualifier) {
                participantObject.results = this.gamesService.getLocalizedMessage("Disqualified", "Disqualified")
              }
            } else if (this.gs.selectedGame[0].GameType == 10) {
                participantObject.metric = participantObject.ruleObject.MyRankingObj.MetricGroupInfos?.[0]?.MyMetricValue && this.gs.selectedGame?.[0]?.SelectedMetrics?.[0]?.conversionType ? this.metricFormatPipe.transform(participantObject.ruleObject.MyRankingObj.MetricGroupInfos[0].MyMetricValue, this.gs.selectedGame[0].SelectedMetrics[0].conversionType) : 0;
                participantObject.results = this.isWinnerBracketTournament(this.gs.selectedGame[0], participantObject.ruleObject);
                participantObject.resultsNumber = this.getBracketTournamentLastRound(participantObject.results, participantObject.ruleObject.MyRankingObj.MyRanking);
            } else {
              participantObject.metric = participantObject.ruleObject.MyRankingObj.MetricGroupInfos[0]?.MyMetricValue && this.gs.selectedGame[0]?.SelectedMetrics[0]?.conversionType ? this.metricFormatPipe.transform(participantObject.ruleObject.MyRankingObj.MetricGroupInfos[0]?.MyMetricValue, this.gs.selectedGame[0].SelectedMetrics[0].conversionType) : 0;
    
              if (this.gs.selectedGame[0].Qualifier) {
                  participantObject.results = participantObject.passed ? this.getWinnerRank(this.gs.selectedGame[0], this.gs.selectedGame[0].GameType, participantObject.ruleObject) : this.gamesService.getLocalizedMessage("Disqualified", "Disqualified");
              } else {
                participantObject.results = this.getWinnerRank(this.gs.selectedGame[0], this.gs.selectedGame[0].GameType, participantObject.ruleObject);
              }
            }
          } else {
            participantObject.metric = 0;
            participantObject.qualifier = 0;
            participantObject.passed = false;
            participantObject.results = this.gamesService.getLocalizedMessage("No_Results", "No Results");
          }
          participantObject.results = this.getResultValueForRaffle(participantObject);
        });
    
        this.participantsInfo = participants?.sort((a, b) => {
          return (a.calculatedCoins > b.calculatedCoins) ? -1 : ((a.calculatedCoins < b.calculatedCoins) ? 1 : 0 );
        }) || [];
          
        this.participantsInfoExport= this.participantsInfo;
         
        if (this.historyTable && this.historyTable.grid && this.historyTable.grid.api)
          this.historyTable.agGrid.api.hideOverlay();
      });
    });
  }

  displayModal (object: any) {
    this.showModal = true;
    this.reversion = false;
    const shouldDisplayCustomRewardMessage = (this.gs.selectedGame[0]?.GameType == 9 || this.gs.selectedGame[0]?.GameType == 10);
    const validOrderStatus = [MarketplaceOrderStatus.ReadyForPickup, MarketplaceOrderStatus.Created, MarketplaceOrderStatus.Processing];
    const isNotValidStatus = (object?: { productState?: number }): boolean => {
      return object && object.productState !== undefined && object.productState !== -1 && !validOrderStatus.includes(object.productState)
    }

    var gridData = [];
    var reversionObj: any = {
      ruleID: this.gs.selectedGame[0].RuleID,
      ruleName: this.gs.selectedGame[0].RuleName,
      startDate: this.gs.selectedInterval[0].StartDate,
      endDate: this.gs.selectedInterval[0].EndDate
    };

    if (object.length > 0) {
      for (var i = 0; i < this.gs.selectedInterval.length; i++) {
        for (var j = 0; j < object.length; j++) {
          var tmpObject: any = {};
          tmpObject.interval = this.gs.selectedInterval[i].DisplayStringDate;
          tmpObject.loginID = object[j].participant.LoginID;
          tmpObject.coins = object[j].calculatedCoins;
          tmpObject.xp = object[j].calculatedXP;
          tmpObject.badges = object[j].badges.length;
          tmpObject.teamID = object[j].participant.TeamID;
          tmpObject.teamName = object[j].participant.Team;
          tmpObject.custom = +(!!object[j].custom && !isNotValidStatus(object[j]));// empty string will be 0 and not empty string will be 1

          gridData.push(tmpObject);
        }
      }

      reversionObj.data = gridData;
      this.navigationService.showOverlay = true;

      const modalRef = this.modalService.open(RevertPayoutDetailsComponent, {
        animation: true,
        backdropClass: 'stopScrolling',
        size: 'lg modal-dialog-noborder-when-loading modal-dialog-centered'
      });

      modalRef.componentInstance.payouts = reversionObj;
      modalRef.componentInstance.shouldDisplayCustomRewardMessage = shouldDisplayCustomRewardMessage;

      modalRef.result.catch(() => {
        //If the user confirmed the payment reversion and after that clicks outside the confirmBox
        //GameHistory table will reloaded
        if (this.gs.confirmBox) {
          this.loadGamesHistory();
        }
      }).finally(() => {
        this.navigationService.showOverlay = false;
        this.showModal = false;
      });
    }
  }

  getClass () {
    return this.enableSelection ? 'btn btn-secondary' : 'btn btn-text body-2';
  }

  selection () {
    if (this.participantsInfo.length > 0 && !this.enableSelection) {
      this.enableSelection = true;
    } else if (this.enableSelection) {
      this.enableSelection = false;
    }
  }

  getTextButton () {
    return this.enableSelection ? "Revert_Payments" : "Cancel_Revert_Payments";
  }

  getWinnerRank(game, gameType, ruleObject) {
    switch (gameType) {
      case 1: //Multiplier Madness
        if (ruleObject.MyRankingObj.MetricGroupInfos && ruleObject.MyRankingObj.MetricGroupInfos.length >= 2 && ruleObject.MyRankingObj.MetricGroupInfos[1].MyMetricValue !== undefined) {
          if (this.isQualified(game, ruleObject.MyRankingObj.MetricGroupInfos[1].MyMetricValue)) {
            return this.gamesService.getLocalizedMessage("Winner", "Winner");
          } else {
            return this.gamesService.getLocalizedMessage("Disqualified", "Disqualified");
          }
        } 
      break;
      case 2: //TopDog
        var result = this.gamesService.getLocalizedMessage("No_Results", "No Results");
        game.TopDogRewards.forEach((reward, index) => {
          var isWinnerTD = this.isWinnerTopDog(game, index, ruleObject);
          if (isWinnerTD) {
            result = isWinnerTD;
          }
        })
        return result;
        break;
      case 3: //Bullseye
        var result = this.gamesService.getLocalizedMessage("No_Results", "No Results");
        game.BullseyeRewards.forEach((reward, index) => {
          var isWinnerBe = this.isWinnerBullseye(game, index, ruleObject);
          if (isWinnerBe) {
            result = isWinnerBe;
          }
        });
        return result;
        break;
      case 5: //Milestone
        var result = this.gamesService.getLocalizedMessage("No_Results", "No Results");

        game.MilestoneRewards.forEach((reward, index) => {
          var isWinnerMi = this.isWinnerMilestone(game, index, ruleObject);
          if (isWinnerMi) {
            result = this.gamesService.getLocalizedMessage("Milestone", "Milestone") + ' ' + (index+1);
          }
        });
        return result;
        break;
      case 8: //TopTeam
        var result = this.gamesService.getLocalizedMessage("No_Results", "No Results");
        game.TopDogRewards.forEach((reward, index) => {
          var isWinnerTD = this.isWinnerTopDog(game, index, ruleObject);
          if (isWinnerTD) {
            result = isWinnerTD;
          }
        });
        return result;
        break;
    }
  }

  isWinnerTopDog(gamedata, index, gameranking) {
    if (gameranking == undefined || gameranking == null
      || gameranking.MyRankingObj == null || gameranking.MyRankingObj.MetricGroupInfos == undefined
      || gameranking.MyRankingObj.MetricGroupInfos == null) return "";

    //Check if the game has qualifier metric
    if (gamedata.Qualifier != null && gameranking.MyRankingObj.MetricGroupInfos.length > 1) {
      if (gameranking.MyRankingObj.MyRanking == (index + 1) && this.isQualified(gamedata, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
        return this.getLocalizedTierText(gameranking.MyRankingObj.MyRanking, 2);
    } else {
      //The game doesn't have qualifier metric
      if (gameranking.MyRankingObj.MyRanking == (index + 1))
        return this.getLocalizedTierText(gameranking.MyRankingObj.MyRanking, 2);
    }
  }

  isWinnerBullseye(game, index, gameranking) {
    if (gameranking == undefined || gameranking == null ||
      gameranking.MyRankingObj == undefined || gameranking.MyRankingObj == null) return "";

    var metricValue = gameranking.MyRankingObj.MetricGroupInfos.length > 0 ? gameranking.MyRankingObj.MetricGroupInfos[0].MyMetricValue : 0;
    var minValue = game.BullseyeRewards[index].Target.Val1;
    var maxValue = game.BullseyeRewards[index].Target.Val2;

    switch (game.BullseyeRewards[index].ComparisonType) {
      case 1: // Greater than
        //Check if the game has qualifier
        if (game.Qualifier != null) {
          if (metricValue >= minValue && this.isQualified(game, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
            return this.getLocalizedTierText(index + 1, 3);
        } else {
          if (metricValue >= minValue)
            return this.getLocalizedTierText(index + 1, 3);
        }
        break;
      case 2: // Less than
        //Check if the game has qualifier
        if (game.Qualifier != null) {
          if (metricValue <= minValue && this.isQualified(game, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
            return this.getLocalizedTierText(index + 1, 3);
        } else {
          if (metricValue <= minValue)
            return this.getLocalizedTierText(index + 1, 3);
        }
        break;
      case 3: // Between
        //Prepare variables for comparing process
        if (game.SelectedMetrics[0].direction == "1"){ // Up Metrics
          if (game.Qualifier != null) {
            if (metricValue >= minValue && metricValue <= maxValue && this.isQualified(game, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
              return this.getLocalizedTierText(index + 1, 3);
          } else {
            if (metricValue >= minValue && metricValue <= maxValue)
              return this.getLocalizedTierText(index + 1, 3);
          }
        } else {
          if (game.Qualifier != null) {
            if (metricValue >= maxValue && metricValue <= minValue && this.isQualified(game, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
              return this.getLocalizedTierText(index + 1, 3);
          } else {
            if (metricValue >= maxValue && metricValue <= minValue)
              return this.getLocalizedTierText(index + 1, 3);
          }
        }

        break;
    }
  }

  isWinnerTeamVsTeam(rewards, participant) {
    var rank = this.gamesService.getLocalizedMessage("No_Results", "No Results");
    for (var i = 0; i < rewards.length; i++) {
      if (rewards[i].Coins.rewardValue == participant.calculatedCoins && rewards[i].XP.rewardValue == participant.calculatedXP) {
        if ((rewards[i].Badge.rewardValue == 0 && participant.badges.length == 0) || (rewards[i].Badge.rewardValue > 0 && participant.badges.length > 0)) {
          rank = this.getLocalizedTierText(i + 1, 2);
          break;
        }
      }
    }
    
    return rank;
    }

  isWinnerBracketTournament(gamedata, gameranking) {
    if (gameranking == undefined || gameranking == null
      || gameranking.MyRankingObj == null || gameranking.MyRankingObj.MetricGroupInfos == undefined
      || gameranking.MyRankingObj.MetricGroupInfos == null) return "";

    return this.getLocalizedRoundText(gameranking.MyRankingObj.MyRanking);
  }

  getBracketTournamentLastRound(result: string, ranking: number): number {
    switch (result){
      case this.gamesService.getLocalizedMessage("Round_1_Final", "Final"):
      case this.gamesService.getLocalizedMessage("Round_2_Semi_Finals", "Semi Finals"):
        return 1;
        break;
      case this.gamesService.getGamesHistoryMessages("No_Wins", "No Wins"):
        return this.gs.selectedGame[0].HistoryBracketTournamentDetails.NumberOfRounds;
        break;
      default:
        return ranking - 1;
        break;
    }
  }

  getLocalizedTierText(tier, gameType) {
    switch (tier) {
      case 1:
        if (gameType == 2) { // TopDog
          return this.gamesService.getLocalizedMessage("First_Place", "1st Place");
        } else if (gameType == 3) { // Bullseye
          return this.gamesService.getLocalizedMessage("Ring_Prize", "Bullseye");
        }
        break;
      case 2: 
        if (gameType == 2) { // TopDog
          return this.gamesService.getLocalizedMessage("Second_Place", "2nd Place");
        } else if (gameType == 3) { // Bullseye
          return this.gamesService.getLocalizedMessage("2nd_Ring", "2nd Ring");
        }
        break;
      case 3:
        if (gameType == 2) { // TopDog
          return this.gamesService.getLocalizedMessage("Third_Place", "3rd Place");
        } else if (gameType == 3) { //Bullseye
          return this.gamesService.getLocalizedMessage("3rd_Ring", "3rd Ring");
        }
        break;
      default:
        var number = tier + this.gamesService.getLocalizedMessage("Th_Symbol", "th") + " ";
        if (gameType == 2) { // TopDog
          number += this.gamesService.getLocalizedMessage("Place", "Place");
        } else if (gameType == 3) { //bullseye
          number += this.gamesService.getLocalizedMessage("Ring", "Ring");
        }
        return number;
        break;
      //Add the next type of games
    }
  }

  getLocalizedRoundText(stage: number) {
    switch (stage) {
      case 1:
        return this.gamesService.getLocalizedMessage("Round_1_Final", "Final");
        break;
      case 2:
        return this.gamesService.getLocalizedMessage("Round_2_Semi_Finals", "Semi Finals");
        break;
      case 3:
        return this.gamesService.getLocalizedMessage("Round_3_Quarter", "Quarters");
        break;
      case 4:
        return this.gamesService.getLocalizedMessage("Round_4_Octaves", "Octaves");
        break;
      default:
        return this.gamesService.getGamesHistoryMessages("No_Wins", "No Wins");
        break;
    }
  }

  isQualified(game, myValue) {
    var isQualified = false;
    if (game == undefined || game == null || game.Qualifier == null) return false;

    switch (game.QualifierLevels.comparerType) {
      case 1: // Greater than
        if (myValue > game.QualifierLevels.leftNumber)
          isQualified = true;
        break;
      case 2: // Less than
        if (myValue < game.QualifierLevels.leftNumber)
          isQualified = true;
        break;
      case 3: // Between
        if (myValue >= game.QualifierLevels.leftNumber && myValue <= game.QualifierLevels.rightNumber)
          isQualified = true;
        break;
      default:
          return
          break;
    }
    return isQualified;
  }

  isWinnerConnect3(metricCompleted, winCasesConnect3) {
    var bin = 0;
    for (let i = 0; i < metricCompleted.length; i++) {
      bin += (metricCompleted[i]) ? Math.pow(2, i) : 0;
    }

    for (let i = 0; i < winCasesConnect3.length; i++) {
      var result = bin & winCasesConnect3[i];
      if (result === winCasesConnect3[i])
        return this.gamesService.getLocalizedMessage("Connect3", "Connect 3");
    }
    return this.gamesService.getLocalizedMessage("No_Connections", "No Connections");
  }

  isWinnerBlackout(metricCompleted, winCasesBlackout) {
    var bin = 0;
    for (let i = 0; i < metricCompleted.length; i++) {
      bin += (metricCompleted[i]) ? Math.pow(2, i) : 0;
    }

    for (let i = 0; i < winCasesBlackout.length; i++) {
      var result = bin & winCasesBlackout[i];
      if (result === winCasesBlackout[i])
        return this.gamesService.getLocalizedMessage("Connected_All", "Connected All");
    }
    return this.gamesService.getLocalizedMessage("Not_All_Connections", "Not All Connections");
  }

  isWinnerMilestone(gamedata, index, gameranking) {
    if (gameranking == undefined || gameranking == null || gameranking.MyRankingObj == undefined || gameranking.MyRankingObj == null) 
      return "";

    if (gameranking.MyRankingObj.MetricGroupInfos && gameranking.MyRankingObj.MetricGroupInfos.length == 0)
      return false;

    //Game has Qualifier
    var isQualifiedFlag = null;
    if (gamedata.Qualifier != null) {
      isQualifiedFlag = this.isQualified(gamedata, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue);
    }

    //Prepare variables for comparing process 
    var metricValue = gameranking.MyRankingObj.MetricGroupInfos[0].MyMetricValue;
    var minValue = gamedata.MilestoneRewards[index].Target.Val1;
    var maxValue = gamedata.MilestoneRewards[index].Target.Val2;
    var isWinner = false;
    
    if (gamedata.SelectedMetrics[0].direction == "1"){ // Up Metrics
      if (gamedata.MilestoneRewards[index].ComparisonType == 1) { //Greater than
        isWinner = (metricValue >= minValue) ? true : false;
      }
      else {
        isWinner = (metricValue >= maxValue || (metricValue >= minValue && metricValue <= maxValue)) ? true : false;
      }
    }
    else{ // Down Metrics    
      if (gamedata.MilestoneRewards[index].ComparisonType == 2) { //Less than
        isWinner = (metricValue <= minValue) ? true : false;
      }
      else {
        isWinner = (metricValue <= maxValue || (metricValue <= maxValue && metricValue >= minValue)) ? true : false;
      }
    }

    //Game has Qualifier
    if (gamedata.Qualifier != null && isQualifiedFlag && isWinner) {
      return true;
    }
    // Game has no Qualifier
    else if (gamedata.Qualifier == null && isQualifiedFlag == null && isWinner) {
      return true;
    }
    return false;
  }

  formatGamesList(gamesFolderList, selectedGame) {
    var gamesListTemp = [];
    var isFirstElement = true;
    
    angular.forEach(gamesFolderList, (gameFolder, key) => {
      if (gameFolder.Games.length > 0) {
        gamesListTemp.push({ RuleName: gameFolder.FolderData.FolderName, gameFolderGroup: true });

        angular.forEach(gameFolder.Games, (gameObject, key) => {
          gameObject.GameObject.underlyingRule.icon = '<div class="glGame-list-icon ' + gameObject.GameObject.iconClass + '"></div>';
          gameObject.GameObject.underlyingRule.RuleName = this.escapeChart(gameObject.GameObject.underlyingRule.RuleName);
          gameObject.GameObject.underlyingRule.isActive = gameObject.GameObject.isActive;
          gameObject.GameObject.underlyingRule.isSelected = selectedGame != null ? gameObject.GameObject.underlyingRule.RuleID == selectedGame.underlyingRule.RuleID :  isFirstElement;
          gamesListTemp.push(Object.assign({}, gameObject.GameObject, gameObject.GameObject.underlyingRule));
          isFirstElement = false;

          //Just to check if connect 3 will require a free space in the middle
          if ((gameObject.GameObject.underlyingRule.GameType == 6 || gameObject.GameObject.underlyingRule.GameType == 7) && gameObject.GameObject.Connect3Positions.length == 8) {
            gameObject.GameObject.Connect3Positions.splice(4, 0, { position: 4, metric: { abbrev: this.gamesService.getLocalizedMessage("Free_Space", "Free Space"), name: this.gamesService.getLocalizedMessage("Free_Space", "Free Space"), metricID: -1, target: null } });
          }

          var isFirstInterval = true;
          angular.forEach(gameObject.GameObject.Intervals, (interval, key) => {
            interval.DisplayStringDate = this.datePipe.transform(interval.StartDate, CVAngularDateFormat) + ' - ' + this.datePipe.transform(interval.EndDate, CVAngularDateFormat);
            if (gameObject.GameObject.underlyingRule.isSelected) {
              interval.isSelected = isFirstInterval;
              isFirstInterval = false;
            } else {
              interval.isSelected = false;
            }
            // Excluding Interval End Date when it is greater than Game's EndDate
            if (gameObject.GameObject.underlyingRule.EndDate != null && ((gameObject.GameObject.Intervals.length - 1) == key)) {
              var EndDate = this.datePipe.transform(gameObject.GameObject.underlyingRule.EndDate, CVAngularDateFormat);
              var intervalEndDate = this.datePipe.transform(interval.EndDate, CVAngularDateFormat);
              if (intervalEndDate > EndDate && gameObject.GameObject.underlyingRule.GameType != 10)
                interval.DisplayStringDate = this.datePipe.transform(interval.StartDate, CVAngularDateFormat);
            }

            if(interval.isSelected){
              this.gs.selectedInterval = [];
              this.gs.selectedInterval.push(interval);
            }
          });

          // Saving game intervals
          if (gameObject.GameObject.underlyingRule.isSelected) {
            this.filteredIntervals$ = of(JSON.parse(JSON.stringify(gameObject.GameObject.Intervals)));
          }
        });

        gamesListTemp.push({ gameFolderGroup: false });
      }

      this.gs.selectedGame[0] = gamesListTemp.filter((item) => {return item.underlyingRule != undefined && item.isSelected})[0];
    });
    return gamesListTemp;
  }

  escapeChart(value: string){
    var tagsToReplace = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;'
    };

    return value.replace(/[&<>]/g, (tag) => {
      return tagsToReplace[tag] || tag;
    });
  }

  setSelectedGame(game: any){
    if(this.gs.selectedGame[0] != game){
      if (this.historyTable && this.historyTable.grid && this.historyTable.grid.api)
        this.historyTable.agGrid.api.hideOverlay();
      this.removeCurrentInterval();
      this.changeRequestAbortStatus(true);
      game.underlyingRule.isSelected = true;
      
      this.gs.selectedInterval = [];
      this.filteredGames$ = of([]);
      this.filteredIntervals$ = of([]);

      this.gs.gamesList.forEach((g)=>{
        if(g.underlyingRule != undefined && game.RuleID != g.RuleID){
          g.underlyingRule.isSelected = false;
        }

        if(g.underlyingRule != undefined && game.RuleID == g.RuleID){
          g.underlyingRule.isSelected = game.underlyingRule.isSelected;
        }
      });
      
      this.gs.selectedGame[0] = game;
      this.filteredGames$ = of(JSON.parse(JSON.stringify(this.gs.gamesList)));
      this.filteredIntervals$ = of(JSON.parse(JSON.stringify(this.gs.selectedGame[0].Intervals)));
    }    
  }

  getRequestId(ruleID?: number, startDate?: string){
    const currentRuleId = ruleID || this.gs.selectedGame[0]?.RuleID;
    const currentStartDate = this.gs.selectedInterval && this.gs.selectedInterval.length > 0 &&  this.gs.selectedInterval[0].StartDate;
    const date = startDate ? startDate : currentStartDate;
    if(currentRuleId && date){
      const prevRequest = `${currentRuleId}-${date}`;
      return prevRequest;
    }
    return '';
  }

  /**
   * 
   * @param status: if status is true, then the request will finish without update the data, if is false then the request will continue normally
   * @param ruleID: the rule id, if there is no rule id we will take the current rule id used in the request, this is use when the user change interval and go back to the same rule with the same interval
   */
  changeRequestAbortStatus(status: boolean = false, ruleID?: number, startDate?: string){
    const requestId = this.getRequestId(ruleID, startDate);
    this.abortRequest[requestId] = status;
  }

  changeTableOverlay(display = false){
    if (this.historyTable && this.historyTable.agGrid && this.historyTable.agGrid.api){
      if(display) this.historyTable.agGrid.api.showLoadingOverlay();
      else this.historyTable.agGrid.api.hideOverlay();
    }
  }

  removeCurrentInterval(){
    this.gs.selectedGame[0].Intervals.filter(i => i.isSelected).forEach((i)=>{
      i.isSelected = false;
    });
  }

  setSelectedInterval(interval: any){
    interval.isSelected = !interval.isSelected;
    this.changeRequestAbortStatus(true);// we cancel the current status of the request
    this.changeTableOverlay(true);

    if(interval.isSelected == true){
      this.filteredIntervals$ = of([]);

      this.gs.selectedGame[0].Intervals.forEach((i)=>{
        if(i.DisplayStringDate == interval.DisplayStringDate){
          i.isSelected = interval.isSelected;
        }else{
          i.isSelected = false;
        }
      });

      this.gs.selectedInterval = [];
      this.gs.selectedInterval.push(interval);
      this.filteredIntervals$ = of(JSON.parse(JSON.stringify(this.gs.selectedGame[0].Intervals)));
      this.changeRequestAbortStatus(false);// if there was a request with this id, then we should allow the request to continue 
    }
  }

  revert(): void {
    this.reversion = true;
    this.cdr.detectChanges();
  }

  onInputChange(newValue: boolean) {
    this.selectAll = newValue;
  }
  
  getFormattedMetric(value, format): string{
    return this.metricFormatPipe.transform(value, format);
  }

  getLocalizedText(key: string, defaultText: string): string{
    return this.gamesService.getLocalizedMessage(key, defaultText);
  }

  getCommonText(key: string, defaultText: string): string {
    return this.gamesService.getCommonMessage(key, defaultText);
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  formatMetricData() {
    if (!this.alreadyFormatted) {
      if (this.gs.selectedGame[0].GameType == 6 || this.gs.selectedGame[0].GameType == 7) {
        this.participantsInfoExport.forEach(p => {
          if (p.connect3Metrics == undefined) { // for participants with no data in metrics
            p.connect3Metrics = [];
          }
          for (let i = 0; i < 9; i++) {
            if (p.connect3Metrics[i] == undefined) {
              p.connect3Metrics[i] = { MetricID: this.gs.selectedGame[0].Connect3Positions[i].metric.metricID };
            }
            if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].Connect3Positions[i].metric.metricID != -1 && p.connect3Metrics[i].MyMetricValue != undefined) {
              let condition = this.gs.selectedGame[0].Connect3Positions[i].metric.direction === "0" ? p.connect3Metrics[i].MyMetricValue < this.gs.selectedGame[0].Connect3Positions[i].targetObj.Target : p.connect3Metrics[i].MyMetricValue > this.gs.selectedGame[0].Connect3Positions[i].targetObj.Target;
              let mark = condition ? ' / ' + this.getCommonText("Yes", "Yes") : ' / ' + this.getCommonText("No", "No");
              p.connect3Metrics[i].MyMetricDisplayValue = p.connect3Metrics && p.connect3Metrics[i] ? this.gamesService.formatterMetricData(this.gs.selectedGame[0].Connect3Positions[i].metric.conversionType, p.connect3Metrics[i].MyMetricValue) + mark : '';
            } else if (this.gs.selectedGame[0].Connect3Positions[i].metric.metricID == -1) {
              p.connect3Metrics[i].MyMetricDisplayValue = this.getCommonText("Yes", "Yes");
            } else {
              p.connect3Metrics[i].MyMetricDisplayValue = '';
            }
          }
        });
        for (let i = 0; i < 9; i++) {
          if (this.gs.selectedGame[0].Connect3Positions[i].metric.metricID != -1)
            this.gs.selectedGame[0].Connect3Positions[i].targetObj.DisplayTarget = this.gamesService.formatterMetricData(this.gs.selectedGame[0].Connect3Positions[i].metric.conversionType, this.gs.selectedGame[0].Connect3Positions[i].targetObj.Target);
        }
      } else if (this.gs.selectedGame[0].GameType == 8) {
        this.participantsInfoExport.forEach(p => {
          // don't format the metric if it's already formatted 
          p.metric = !isNaN(p.metric) ? this.gamesService.formatterMetricData(this.gs.selectedGame[0].SelectedMetrics[0].conversionType, p.metric) : p.metric;
        });
      }
    }
  }

  setColumns(obj) {
    this.columns = obj;
  }

  setTotalRow(obj) {
    this.totalRow = obj;
    this.totalRow.badgest = this.totalRow.badges;
  }

  setParticipantsSorted(obj) {
    this.participantsInfoExport = obj;
    this.alreadyFormatted = false;
  }

  exportHistory() {
    if (!this.alreadyFormatted) {
      this.formatMetricData();
      // if(this.totalRow !== 'undefined')
      //   this.participantsInfoExport.push(this.totalRow);
    }
    this.exportData = {
      ghObjects: this.participantsInfoExport,
      game: this.gs.selectedGame[0],
      columnStates: this.columns,
      totalRow:this.totalRow !== 'undefined'?this.totalRow: null
    }
    this.alreadyFormatted = true;
  }
}
